//@flow
import React from 'react';

import AddZoneMapModal from 'common/entity/mapMaster/AddZoneMapModal';
import ZoneMapModal from 'common/entity/mapMaster/ZoneMapModal';

type Props = {
    isAddZoneMapActive: boolean,
    mapCenter?: Array<number>,
    homebaseId?: ?string,
    teamId?: ?string,
    clientId: ?string,
    goToCreateMap: () => void,
    onCancelCreateMap: () => void
};

class ZoneMapModalContainer extends React.PureComponent<Props> {
    render() {
        const {
            isAddZoneMapActive,
            homebaseId,
            teamId,
            goToCreateMap,
            onCancelCreateMap,
            ...others
        } = this.props;
        return isAddZoneMapActive && (!homebaseId || !teamId) ? (
            <AddZoneMapModal
                onCreate={goToCreateMap}
                onCancel={onCancelCreateMap}
                defaultHomebaseId={homebaseId}
                defaultTeamId={teamId}
            />
        ) : (
            <ZoneMapModal {...others} />
        );
    }
}

export default ZoneMapModalContainer;
